export const DEATHS_ON_DELETE_REQUESTED = 'DEATHS_ON_DELETE_REQUESTED';
export const DEATHS_ON_DELETE_SUCCEEDED = 'DEATHS_ON_DELETE_SUCCEEDED';
export const DEATHS_ON_DELETE_FAILED = 'DEATHS_ON_DELETE_FAILED';

export const DEATHS_ON_GET_ALL_REQUESTED = 'DEATHS_ON_GET_ALL_REQUESTED';
export const DEATHS_ON_GET_ALL_SUCCEEDED = 'DEATHS_ON_GET_ALL_SUCCEEDED';
export const DEATHS_ON_GET_ALL_FAILED = 'DEATHS_ON_GET_ALL_FAILED';

export const DEATHS_ON_GET_FORM_REQUESTED = 'DEATHS_ON_GET_FORM_REQUESTED';
export const DEATHS_ON_GET_FORM_SUCCEEDED = 'DEATHS_ON_GET_FORM_SUCCEEDED';
export const DEATHS_ON_GET_FORM_FAILED = 'DEATHS_ON_GET_FORM_FAILED';

export const DEATHS_ON_GET_ONE_REQUESTED = 'DEATHS_ON_GET_ONE_REQUESTED';
export const DEATHS_ON_GET_ONE_SUCCEEDED = 'DEATHS_ON_GET_ONE_SUCCEEDED';
export const DEATHS_ON_GET_ONE_FAILED = 'DEATHS_ON_GET_ONE_FAILED';

export const DEATHS_ON_SAVE_REQUESTED = 'DEATHS_ON_SAVE_REQUESTED';
export const DEATHS_ON_SAVE_SUCCEEDED = 'DEATHS_ON_SAVE_SUCCEEDED';
export const DEATHS_ON_SAVE_FAILED = 'DEATHS_ON_SAVE_FAILED';
